module.exports = __webpack_public_path__ + "static/media/6510.cff1f6c1.jpg";